export const CONDUCTORS = 'conductors';
export const AUTH_TOKEN = 'auth-token';
export const REFRESH_TOKEN = 'refresh-token';
export const IS_LOCKED = 'is-locked';
export const COMPANY_DOCTORS = 'companyDoctors';
export const JOBTITLES = 'jobtitles';
